import MarkdownText from '~/components/MarkdownText';
import privacyPolicy from '~/docs/privacyPolicy.md';
export const PrivacyPolicy = (): JSX.Element => <MarkdownText data-sentry-element="MarkdownText" data-sentry-component="PrivacyPolicy" data-sentry-source-file="index.tsx">{privacyPolicy.toString()}</MarkdownText>;
export default PrivacyPolicy;